class LeaguesController {
  constructor(LeaguesFactory, $rootScope, $filter, ngDialog, Levels) {
    "ngInject";
    const vm = this;

    let $translate = $filter("translate");

    vm.rootScope = $rootScope;
    vm.mixedLeague = {};
    vm.level = { id: Levels.WHITE, name: "White" };
    vm.levels = [
      { id: Levels.WHITE, name: "White" },
      { id: Levels.BLACK, name: "Black" },
      { id: Levels.BLUE, name: "Blue" },
      { id: Levels.RED, name: "Red" },
      { id: Levels.YELLOW, name: "Yellow" },
      { id: Levels.GREEN, name: "Green" },
    ];

    vm.$onInit = () => {
      vm.showLeagueForm = false;
      reloadLeagues();
    };

    vm.hasPermission = (permission) => {
      return vm.rootScope.user.canDo(permission);
    };

    vm.gridOptions = {
      enableSorting: true,
      paginationPageSizes: [50, 100, 150],
      paginationPageSize: 50,
      enableColumnMenus: false,
      enableFiltering: true,
      columnDefs: [
        {
          field: "league_name",
          enableFiltering: true,
          name: $translate("LEAGUE_NAME"),
        },
        {
          visible: $rootScope.isSAAF,
          field: "level",
          enableFiltering: true,
          name: $translate("LEVEL"),
          width: "100",
          cellTemplate: `<div class="ui-grid-cell-contents ui-grid-align-c">
			{{grid.appScope.vm.getLevelName(row.entity)}}
			</div>`,
        },
        {
          field: "league_priority",
          enableFiltering: true,
          name: $translate("LEAGUE_ORDER"),
          width: "100",
        },
        {
          field: "type",
          enableFiltering: true,
          name: $translate("BOW_TYPE"),
          width: "100",
        },
        {
          field: "actions",
          enableFiltering: false,
          name: $translate("ACTIONS"),
          headerCellClass: "text-center",
          cellTemplate:
            "" +
            "<div " +
            'class="ui-grid-cell-contents ui-grid-align-c p-t-5">' +
            '<div class="buttons">' +
            '<button class="btn btn-sm btn-warning" translate ' +
            'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.EDIT_LEAGUE)" ' +
            'ng-click="grid.appScope.vm.openForm(row.entity)">EDIT</button> ' +
            '<button class="btn btn-sm btn-danger" translate ' +
            'ng-if="grid.appScope.vm.hasPermission(grid.appScope.vm.rootScope.permissions.DELETE_LEAGUE)" ' +
            'ng-click="grid.appScope.vm.deleteLeague(row.entity.league_id)">DELETE</button> ' +
            "</div>" +
            "</div>",
          width: "240",
        },
      ],
    };

    vm.submit = () => {
      vm.league.level = vm.level.id;
      if (vm.mixedLeague) {
        vm.league.mixed_league_id = vm.mixedLeague.league_id;
      }
      if (vm.league.league_id) {
        LeaguesFactory.update(vm.league.league_id, vm.league).then(
          (response) => {
            ngDialog.open({ template: "successTemplate" });
            reloadLeagues();
            vm.league = response.data;
          }
        );
      } else {
        LeaguesFactory.create(vm.league).then((response) => {
          ngDialog.open({ template: "successTemplate" });
          reloadLeagues();
          vm.league = response.data;
        });
      }
    };

    vm.deleteLeague = (leagueId) => {
      ngDialog
        .openConfirm({
          template: "confirmTemplate",
          data: {
            message: $translate("CONFIRM_DELETE_LEAGUE"),
          },
        })
        .then(() => {
          LeaguesFactory.delete(leagueId).then((response) => {
            ngDialog.open({ template: "successTemplate" });
            reloadLeagues();
          });
        });
    };

    vm.openForm = (league) => {
      vm.league = {};
      if (league) {
        angular.copy(league, vm.league);
        vm.level = vm.levels.find((l) => l.id === vm.league.level);
        if (league.mixed_league_id) {
          vm.mixedLeague = vm.leagues.find(
            (l) => l.league_id === league.mixed_league_id
          );
        } else {
          vm.mixedLeague = {};
        }
      }
      vm.showLeagueForm = true;
    };

    vm.closeForm = () => {
      vm.showLeagueForm = false;
    };

    vm.getLevelName = (league) => {
      return vm.levels.find((l) => l.id === league.level).name;
    };

    function reloadLeagues() {
      LeaguesFactory.getAll().then((response) => {
        vm.leagues = response.data;
        vm.gridOptions.data = response.data;
      });
    }
  }
}

export default LeaguesController;



// WEBPACK FOOTER //
// ./client/app/components/leagues/leagues.controller.js